import styled, { css } from 'styled-components/macro'

export const RootS = styled.div`
  max-width: 900px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px 32px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.alert};
  
  p {
    ${(props) => css(props.theme.fonts.types.body1)}
  }
`
